<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space" v-model="activeTab">
    <!-- My Lab Orders -->
    <tab-pane label="my-lab-orders">
      <template slot="label">
        <i class="fas fa-running"></i>
      </template>
      <div style="height:100%">
        <div class="pb-2">
          <div class="col-12 col-md-12 form-group">
            <div class="" @click="clearlabOrderSearchText">
              <fg-input :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :addon-right-icon="!labOrderSearchText? 'now-ui-icons ui-1_zoom-bold': 'now-ui-icons ui-1_simple-remove'" type="text" v-model="labOrderSearchText" @keyup="getLabOrders()"></fg-input>
            </div>
          </div>
          <!--          <div class="col-12 col-md-12 form-group">
            <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="latestStatusQuery">
              <el-option class="select-primary" value="" :label="$t('message.All Orders')" @click.native="onFilterChange('')"></el-option>
              <el-option class="select-primary" value="Accepted" :label="$t('message.Accepted Orders')" @click.native="onFilterChange('Accepted')"></el-option>
              <el-option class="select-primary" value="Sample Collected" :label="$t('message.Sample Collected ?')" @click.native="onFilterChange('Sample Collected')"></el-option>
            </el-select>
          </div> -->
        </div>
        <div v-if="laborders && laborders.length > 0" style="height: calc(100% - 58px);overflow: scroll;">
          <div class="col-lg-12 col-md-12 col-sm-12" v-for="laborder in laborders" :key="laborder._id">
            <card class="card-stats">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div v-if="laborder.referenceId" class="row appointment-id justify-content-end pr-4">
                    <div class="" style="font-size: small; font-weight: 600;">
                      <span style="margin-right: 0.5em">
                        <i class="fas fa-hashtag"></i>
                      </span>
                      <span>{{ laborder.referenceId }}</span>
                    </div>
                  </div>
                  <div class="row visit-details details">
                    <div class="col-3 col-md-4 pr-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <div v-if="laborder.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                            <span>
                              <i class="fa fa-mars"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                            <span>
                              <i class="fa fa-venus"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                            <span>
                              <i class="fa fa-transgender-alt"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-md-8 right">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{ laborder.patient.firstName }}
                              {{ laborder.patient.lastName }}</span>
                          </div>
                        </div>

                        <div class="row" v-if="laborder.sampleCollectionTime">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLaborderDatetime(laborder.sampleCollectionTime)}}</span>
                          </div>
                        </div>
                        <div class="row" v-if="laborder.createdUser">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user-nurse"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>
                              {{ laborder.createdUser.firstName }} {{ laborder.createdUser.lastName }}
                            </span>
                          </div>
                        </div>

                        <div class="row" v-if="laborder.endpoint">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clinic-medical"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>
                              {{ laborder.endpoint}}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fas fa-vial"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{laborder.sampleCollectionLocation.geolocation.landmark}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLabOrderStatus(laborder.latestStatus)}}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button v-if="(laborder.latestStatus =='Created')" type="primary" class="btn-padding light mr-2" round @click.native="acceptLabOrder(laborder)">
                  <i slot="label" class="fa fa-check"></i>
                  {{ $t("message.Accept") }}
                </n-button>

                <n-button v-if="(laborder.latestStatus !='Created' ) && (laborder.latestStatus !='Blocked')" type="primary" class="btn-padding light mr-2" round @click.native="viewLabOrderDetails(laborder)">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
              </div>
            </card>
          </div>
          <infinite-loading spinner="waveDots" @infinite="getLabOrders">
            <span slot="no-more">{{ $t("message.No more lab orders") }}</span>
            <span slot="no-results"></span>
          </infinite-loading>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!laborders || laborders.length < 1">
          <lab-order-svg></lab-order-svg>
          <i>{{ $t("message.No lab orders for you, you might want to check new lab orders") }}</i>
        </div>
      </div>
    </tab-pane>

    <!-- New Lab Orders -->
    <tab-pane label="new-lab-orders">
      <template slot="label">
        <i class="fa fa-microscope"></i>
      </template>
      <div style="height:100%">
        <div class="pb-2">
          <div class="col-12 col-md-12 form-group">
            <div class="" @click="clearlabOrderSearchText">
              <fg-input :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :addon-right-icon="!labOrderSearchText? 'now-ui-icons ui-1_zoom-bold': 'now-ui-icons ui-1_simple-remove'" type="text" v-model="labOrderSearchText" @keyup="getLabOrders()"></fg-input>
            </div>
          </div>
        </div>
        <div v-if="laborders && laborders.length > 0" style="height: calc(100% - 58px);overflow: scroll;">
          <div class="col-lg-12 col-md-12 col-sm-12" v-for="laborder in laborders" :key="laborder._id">
            <card class="card-stats">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div v-if="laborder.referenceId" class="row appointment-id justify-content-end pr-4">
                    <div class="" style="font-size: small; font-weight: 600;">
                      <span style="margin-right: 0.5em">
                        <i class="fas fa-hashtag"></i>
                      </span>
                      <span>{{ laborder.referenceId }}</span>
                    </div>
                  </div>
                  <div class="row visit-details details">
                    <div class="col-3 col-md-4 pr-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <div v-if="laborder.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                            <span>
                              <i class="fa fa-mars"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                            <span>
                              <i class="fa fa-venus"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                            <span>
                              <i class="fa fa-transgender-alt"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-md-8 right">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{ laborder.patient.firstName }}
                              {{ laborder.patient.lastName }}</span>
                          </div>
                        </div>

                        <div class="row" v-if="laborder.sampleCollectionTime">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLaborderDatetime(laborder.sampleCollectionTime)}}</span>
                          </div>
                        </div>
                        <div class="row" v-if="laborder.createdUser">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user-nurse"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>
                              {{ laborder.createdUser.firstName }} {{ laborder.createdUser.lastName }}
                            </span>
                          </div>
                        </div>

                        <div class="row" v-if="laborder.endpoint">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clinic-medical"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>
                              {{ laborder.endpoint}}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fas fa-vial"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{laborder.sampleCollectionLocation.geolocation.landmark}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLabOrderStatus(laborder.latestStatus)}}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button v-if="(laborder.latestStatus =='Created')" type="primary" class="btn-padding light mr-2" round @click.native="acceptLabOrder(laborder)">
                  <i slot="label" class="fa fa-check"></i>
                  {{ $t("message.Accept") }}
                </n-button>

                <n-button v-if="(laborder.latestStatus !='Created' ) && (laborder.latestStatus !='Blocked')" type="primary" class="btn-padding light mr-2" round @click.native="viewLabOrderDetails(laborder)">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
              </div>
            </card>
          </div>
          <infinite-loading spinner="waveDots" @infinite="getLabOrders">
            <span slot="no-more">{{ $t("message.No more lab orders") }}</span>
            <span slot="no-results"></span>
          </infinite-loading>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!laborders || laborders.length < 1">
          <lab-order-svg></lab-order-svg>
          <i>{{ $t("message.No new lab orders for you, you might want to check my lab orders") }}</i>
        </div>
      </div>
    </tab-pane>

    <!--Historic Lab Orders -->
    <tab-pane label="historic-lab-orders">
      <template slot="label">
        <i class="fa fa-history"></i>
      </template>
      <div style="height:100%">
        <div class="col-12 col-md-12 form-group pb-2 mb-0">
          <div class="" @click="clearlabOrderSearchText">
            <fg-input :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :addon-right-icon="!labOrderSearchText? 'now-ui-icons ui-1_zoom-bold': 'now-ui-icons ui-1_simple-remove'" type="text" v-model="labOrderSearchText" @keyup="getLabOrders()"></fg-input>
          </div>
        </div>
        <div v-if="laborders && laborders.length > 0" style="height: calc(100% - 58px);overflow: scroll;">
          <div class="col-lg-12 col-md-12 col-sm-12" v-for="laborder in laborders" :key="laborder._id">
            <card class="card-stats">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div v-if="laborder.referenceId" class="row appointment-id justify-content-end pr-4">
                    <div class="" style="font-size: small; font-weight: 600;">
                      <span style="margin-right: 0.5em">
                        <i class="fas fa-hashtag"></i>
                      </span>
                      <span>{{ laborder.referenceId }}</span>
                    </div>
                  </div>
                  <div class="row visit-details details">
                    <div class="col-3 col-md-4 pr-0">
                      <div class="row">
                        <div class="col-12 text-center">
                          <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                          <br />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <div v-if="laborder.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                            <span>
                              <i class="fa fa-mars"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                            <span>
                              <i class="fa fa-venus"></i>
                            </span>
                          </div>
                          <div v-if="laborder.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                            <span>
                              <i class="fa fa-transgender-alt"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-9 col-md-8 right">
                      <slot>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-user"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{ laborder.patient.firstName }}
                              {{ laborder.patient.lastName }}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-mobile"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{laborder.patient.mobileNumber}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-clock"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLaborderDatetime(laborder.sampleCollectionTime)}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-1 col-3 text-center">
                            <span>
                              <i class="fa fa-question-circle"></i>
                            </span>
                          </div>
                          <div class="col-md-8 col-9 pl-0">
                            <span>{{getLabOrderStatus(laborder.latestStatus)}}</span>
                          </div>
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="stats text-center" slot="footer">
                <n-button v-if="(laborder.latestStatus !='Created' ) && (laborder.latestStatus !='Blocked')" type="primary" class="btn-padding light mr-2" round @click.native="viewLabOrderDetails(laborder)">
                  <i slot="label" class="fa fa-eye"></i>
                  {{ $t("message.View") }}
                </n-button>
              </div>
            </card>
          </div>
          <infinite-loading spinner="waveDots" @infinite="getLabOrders">
            <span slot="no-more">{{ $t("message.No more lab orders") }}</span>
            <span slot="no-results"></span>
          </infinite-loading>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!laborders || laborders.length < 1">
          <lab-order-svg></lab-order-svg>
          <i>{{ $t("message.No lab orders for you") }}</i>
        </div>
      </div>
    </tab-pane>
  </tabs>
</template>
<script>
import avatarImage from "@/assets/img/proAvatar.png";
import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import socket from "@/services/socket";

import LabOrderSvg from "../components/svg_images/LabOrderSvg.vue";

export default {
  name: "nurse-home",
  components: {
    TabPane,
    Tabs,
    LabOrderSvg,
  },
  data() {
    return {
      avatarImage,
      laborders: [],
      labordersPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 3,
      },
      latestStatusQuery: "",
      labOrderSearchText: "",
      activeTab: "my-lab-orders",
      getlaborderExecuting: false,
    };
  },
  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
  },
  async mounted() {
    if (this.user) {
      this.$root.onBackButton = () => {
        let that = this;
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        } else {
          swal
            .fire({
              title: that.$t("message.Are you sure?"),
              confirmButtonText: that.$t("message.Exit"),
              showCancelButton: true,
              cancelButtonText: that.$t("message.Stay"),
            })
            .then(async (result) => {
              if (result && result.value) {
                navigator.app.exitApp();
              }
            });
        }
      };
      this.changeAppHeaderText("my-lab-orders");
      await this.$store.dispatch("getSettings");
      await this.$store.dispatch(
        "getEndpoint",
        this.user.endpoint.name || this.user.endpoint
      );

      socket.emit("joinRoom", {
        type: "endpoint",
        id: this.endpoint.name,
        userId: this.user._id,
      });

      socket.on("labOrderaccepted", (data) => {
        if (data.userId != this.user._id) {
          this.getLabOrders();
        }
      });

      this.initSocket();
      this.getLabOrders();
    }
  },

  methods: {
    initSocket() {
      console.log("labrunner - initSocket");
      //joining socket to be extra sure
      //Join User Room
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      // //subscribe to mqtt topic using socket
      // socket.emit("subscribe", { topic: this.user._id });

      // //Join all caregroup rooms
      // this.user.caregroups.forEach((caregroup) => {
      //   socket.emit("joinRoom", { type: "caregroup", id: caregroup });
      //   socket.emit("subscribe", { topic: caregroup });
      // });
    },
    onFilterChange(filter) {
      this.latestStatusQuery = filter;
      this.getLabOrders();
    },
    onTabChange(label) {
      this.activeTab = label;
      this.$forceUpdate();
    },
    async getLabOrders($state) {
      try {
        if (!this.getlaborderExecuting) {
          this.getlaborderExecuting = true;
          if (this.endpoint) {
            if (!$state) {
              this.laborders = [];
              this.labordersPagination = {
                pageNumber: 1,
                totalPages: 0,
                pageSize: 3,
              };
            }
            let query = { lab: this.endpoint.name, labRunnerId: this.user._id };
            if (this.latestStatusQuery) {
              query["latestStatus"] = this.latestStatusQuery;
            }
            if (this.labOrderSearchText) {
              query["patient"] = this.labOrderSearchText;
            }
            if (this.activeTab == "new-lab-orders") {
              query["excludeStatuses"] = [
                "Sample Deposited",
                "Accepted",
                "Sample Collected",
                "Report Uploaded",
              ];
            } else if (this.activeTab == "my-lab-orders") {
              query["excludeStatuses"] = [
                "Sample Deposited",
                "Created",
                "Report Uploaded",
              ];
            } else {
              query["excludeStatuses"] = [
                "Created",
                "Accepted",
                "Sample Collected",
              ];
            }
            let response = await this.$store.dispatch("getLabOrders", {
              pageNumber: this.labordersPagination.pageNumber,
              query: query,
            });
            console.log({
              pageNumber: this.labordersPagination.pageNumber,
              query: query,
            });
            if (response && response.data && response.data.length) {
              //Fix for duplicate cards when patient search is cleared
              response.data.forEach((data) => {
                let exists = this.laborders.some((laborder) => {
                  return laborder._id == data._id;
                });
                if (!exists) {
                  this.laborders.push(data);
                }
              });
              // this.laborders.push(...response.data);
              this.labordersPagination.totalPages = response.totalPages;
              this.labordersPagination.pageNumber += 1;
              $state && $state.loaded();
            } else {
              $state && $state.complete();
            }
            this.getlaborderExecuting = false;
          }
        }
      } catch (e) {
        this.laborders = [];
        console.log(e);
      }
    },
    async acceptLabOrder(laborder) {
      let that = this;
      swal
        .fire({
          title: that.$t("message.You will be accepting this lab order"),
          showCancelButton: true,
          closeOnConfirm: true,
          confirmButtonText: that.$t("message.OK"),
          cancelButtonText: that.$t("message.Cancel"),
        })
        .then(async (confirm) => {
          if (confirm.value) {
            try {
              let response = await this.$store.dispatch("acceptlabOrder", {
                laborderId: laborder._id,
              });

              if (response) {
                swal.fire({
                  type: "success",
                  title: that.$t("message.Lab Order accepted successfully!"),
                  timer: 3000,
                });
                this.viewLabOrderDetails(laborder);
                this.getLabOrders();
              } else {
                swal.fire({
                  type: "warning",
                  title: that.$t("message.Could not accept the lab order"),
                  timer: 3000,
                });
              }
            } catch (e) {
              console.log(e.response.status);

              if (e.response.status == 406) {
                swal.fire({
                  type: "warning",
                  title: that.$t("message.Lab order already accepted"),
                  timer: 3000,
                });
              } else {
                socket.emit("labOrderaccepted", {
                  endpointName: this.endpoint.name,
                  labOrderId: this.laborder._id,
                  userId: this.user._id,
                });
                swal.fire({
                  type: "warning",
                  title: that.$t("message.Could not accept the lab order"),
                  timer: 3000,
                });
              }
            }
          }
        });
    },
    viewLabOrderDetails(laborder) {
      this.$router.push({ path: "/viewlaborderdetails/" + laborder._id });
    },
    getLaborderDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
    getLabOrderStatus(status) {
      let msgVal = status;
      if (status == "Created") {
        msgVal = this.$t("message.Created");
      }
      if (status == "Accepted") {
        msgVal = this.$t("message.Accepted");
      }
      if (status == "Sample Collected") {
        msgVal = this.$t("message.Sample collected");
      }
      if (status == "Sample Deposited") {
        msgVal = this.$t("message.Sample deposited");
      }
      if (status == "Report Uploaded") {
        msgVal = this.$t("message.Report uploaded");
      }
      return msgVal;
    },
    clearlabOrderSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.labOrderSearchText = "";
      }
    },
  },
  beforeDestroy() {
    this.$root.onBackButton = null;
  },
  watch: {
    activeTab: function (value) {
      this.changeAppHeaderText(value);
      console.log("Active tab", value);
      this.latestStatusQuery = value == "new-lab-orders" ? "Created" : "";
      this.laborders = [];
      this.labOrderSearchText = "";
      this.labordersPagination = {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 3,
      };
      this.getLabOrders();
      /*       //Handling switch tab from live to historic when latestStatusQuery is ALL Orders
      if (this.latestStatusQuery == "" && value == "historic-lab-orders") {
        //Since latestStatusQuery watch will not execute in this condition
        this.getLabOrders();
      } */
    },
  },
};
</script>

<style>
#home .stats {
  text-align: center;
}
.search-block {
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}
.not-found-img {
  width: 100%;
}
.card-header-nav {
  background: var(--color-primary);
}
.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}
.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

#home .tab-content.tab-subcategories {
  width: 100%;
}
.main-panel > .content {
  margin-top: 0px;
}

.icon .nav-link {
  padding: 0px 15px !important;
}
.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
@media screen and (max-width: 412px) {
  /deep/.nav-pills .nav-item .nav-link {
    min-width: 68px;
  }
}

/deep/.nav-pills .nav-item .nav-link {
  min-width: 60px;
}

#care-card-front,
.care-card-description {
  height: 18em;
}
.care-card-description {
  overflow: scroll;
}
.image-text-overlay {
  font-size: 0.7em;
}
.appointments-wrapper {
  margin-top: 1em;
}
.icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin: auto;
  margin-top: 8px;
  border-radius: 30%;
}
.icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 2.8;
  font-size: 25px;
}
.link-label {
  margin-top: 1em;
  display: block;
}
.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}
/deep/ .tab-content {
  height: calc(100% - 68px);
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}
.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.message-list:first-child {
  border-top: none;
}
.message-list.selected {
  background-color: whitesmoke;
}
.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}
.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}
.icon.icon-circle img {
  padding: 20px;
}

/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}
/deep/ .sc-message {
  width: 90%;
}
/deep/ .sc-header {
  display: none;
}
/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}
/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}
/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

.boxes {
  --size: 32px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}
.boxes .box {
  width: var(--size);
  height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  transform-style: preserve-3d;
}
.boxes .box:nth-child(1) {
  transform: translate(100%, 0);
  animation: box1 var(--duration) linear infinite;
}
.boxes .box:nth-child(2) {
  transform: translate(0, 100%);
  animation: box2 var(--duration) linear infinite;
}
.boxes .box:nth-child(3) {
  transform: translate(100%, 100%);
  animation: box3 var(--duration) linear infinite;
}
.boxes .box:nth-child(4) {
  transform: translate(200%, 0);
  animation: box4 var(--duration) linear infinite;
}
.boxes .box > div {
  --background: #45b2fe;
  --top: auto;
  --inset-inline-end: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  inset-inline-end: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX))
    translateZ(var(--translateZ));
}
.boxes .box > div:nth-child(1) {
  --top: 0;
  --left: 0;
}
.boxes .box > div:nth-child(2) {
  --background: #369ae0;
  --inset-inline-end: 0;
  --rotateY: 90deg;
}
.boxes .box > div:nth-child(3) {
  --background: #aadcff;
  --rotateX: -90deg;
}
.boxes .box > div:nth-child(4) {
  --background: #dbe3f4;
  --top: 0;
  --left: 0;
  --translateZ: calc(var(--size) * 3 * -1);
}
@keyframes box1 {
  0%,
  50% {
    transform: translate(100%, 0);
  }
  100% {
    transform: translate(200%, 0);
  }
}
@keyframes box2 {
  0% {
    transform: translate(0, 100%);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
}
@keyframes box3 {
  0%,
  50% {
    transform: translate(100%, 100%);
  }
  100% {
    transform: translate(0, 100%);
  }
}
@keyframes box4 {
  0% {
    transform: translate(200%, 0);
  }
  50% {
    transform: translate(200%, 100%);
  }
  100% {
    transform: translate(100%, 100%);
  }
}
html {
  -webkit-font-smoothing: antialiased;
}
* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}
body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}
body .dribbble {
  position: fixed;
  display: block;
  inset-inline-end: 20px;
  bottom: 20px;
}
body .dribbble img {
  display: block;
  height: 28px;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ .modal-dialog {
  max-width: inherit;
}

@media (min-width: 768px) {
  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {
  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {
  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}
</style>
